import * as types from "../actions/types";

const initialState = {
  loading: null,
  data: null,
  error: null,
  uploading: false,
  processing: false,
  csvData: null,
  failCount: 0,
};

const dataReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.UPLOAD_DATA_SUCCESS:
      // clear previous data
      return {
        ...state,
        uploading: false,
      };
    case types.UPLOAD_DATA_FAILURE:
      return {
        ...state,
        error: payload,
        uploading: false,
        loading: false,
      };
    case types.PROCESS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
        processing: false,
      };
    case types.PROCESS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: payload,
        processing: false,
      };

    case types.DATA_LOADING:
      return {
        ...state,
        loading: true,
      };

    case types.DATA_UPLOADING:
      return {
        ...state,
        uploading: true,
      };
    case types.DATA_PROCESSING:
      return {
        ...state,
        processing: true,
      };
    case types.CSV_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        csvData: payload,
      };
    case types.CSV_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case types.INCREMENT_FAIL_COUNT:
      return {
        ...state,
        failCount: ++state.failCount,
      };

    case types.RESET_FAIL_COUNT:
      return {
        ...state,
        failCount: 0,
      };
    default:
      return state;
  }
};

export default dataReducer;
